<template>
  <div :class="{'import-error-card':errorList.length>0}">
    <el-alert v-for="(item, index) in errorList" :key="index" closable style="margin: 0 6px 6px 0;width:fit-content;padding-right: 30px;"
              :title="`${item.rowNum}行${item.errorMsg}`"
              type="error"
              effect="dark">
    </el-alert>
  </div>
</template>

<script>
export default {
  name: 'ImportErrorCard',
  props: {
    errorList: {
      type: Array,
      default: () => []
    }
  },
  data(){
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
.import-error-card {
  display: flex;flex:1;flex-wrap: wrap; margin: 6px 0 6px 0;
}
</style>
